import { createContext, useContext } from 'react';

interface FirebaseContextInterface {
  authenticated: boolean;
  loading: boolean;
}

const initialContext: FirebaseContextInterface = {
  authenticated: false,
  loading: true,
};

export const FirebaseContext = createContext<FirebaseContextInterface>(initialContext);
export const useFirebase = () => useContext(FirebaseContext);
